export const isEmptyArr = (arr: any[]) => {
  return arr.length === 0
}
